export const mockSectionFields = [
  {
    name: "section_name",
    type: "text",
    label: "Section Name",
    gridColumn: "span 4",
  },
];
